var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.tableWidth')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.tableWidth),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "tableWidth", $$v)
      },
      expression: "optionModel.tableWidth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.tableHeight')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.tableHeight),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "tableHeight", $$v)
      },
      expression: "optionModel.tableHeight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.customClass')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: (_vm.optionModel.customClass),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "customClass", $$v)
      },
      expression: "optionModel.customClass"
    }
  }, _vm._l((_vm.cssClassList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.showIndex')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.showIndex),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "showIndex", $$v)
      },
      expression: "optionModel.showIndex"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.showCheckBox')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.showCheckBox),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "showCheckBox", $$v)
      },
      expression: "optionModel.showCheckBox"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.showPagination')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.showPagination),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "showPagination", $$v)
      },
      expression: "optionModel.showPagination"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.smallPagination')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.smallPagination),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "smallPagination", $$v)
      },
      expression: "optionModel.smallPagination"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.showSummary')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.showSummary),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "showSummary", $$v)
      },
      expression: "optionModel.showSummary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.stripe')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.stripe),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "stripe", $$v)
      },
      expression: "optionModel.stripe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.rowSpacing')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "max": 20
    },
    model: {
      value: (_vm.optionModel.rowSpacing),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "rowSpacing", $$v)
      },
      expression: "optionModel.rowSpacing"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.widgetSize')
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.refreshTableLayout
    },
    model: {
      value: (_vm.optionModel.tableSize),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "tableSize", $$v)
      },
      expression: "optionModel.tableSize"
    }
  }, _vm._l((_vm.widgetSizes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.tableColEdit')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.openSetting
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.editAction')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.optionModel.dsEnabled),
      expression: "!optionModel.dsEnabled"
    }],
    attrs: {
      "label": _vm.i18nt('designer.setting.tableDataEdit')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.openTableDataEdit
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.editAction')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dsEnabled')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.dsEnabled),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dsEnabled", $$v)
      },
      expression: "optionModel.dsEnabled"
    }
  })], 1), _vm._v(" "), (!!_vm.optionModel.dsEnabled) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dsName')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getDataSetList
    },
    model: {
      value: (_vm.optionModel.dsName),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dsName", $$v)
      },
      expression: "optionModel.dsName"
    }
  }, _vm._l((_vm.dataSourceList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "title": item.description,
        "label": item.uniqueName,
        "value": item.uniqueName
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!!_vm.optionModel.dsEnabled) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dataSetName')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.optionModel.dataSetName),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dataSetName", $$v)
      },
      expression: "optionModel.dataSetName"
    }
  }, _vm._l((_vm.dataSetList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "title": item.remark,
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.treeDataEnabled')
    }
  }, [_c('el-switch', {
    on: {
      "change": _vm.handleTDEChange
    },
    model: {
      value: (_vm.optionModel.treeDataEnabled),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "treeDataEnabled", $$v)
      },
      expression: "optionModel.treeDataEnabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.rowKeyOfTreeData')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.rowKey),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "rowKey", $$v)
      },
      expression: "optionModel.rowKey"
    }
  })], 1), _vm._v(" "), (!!_vm.optionModel.treeDataEnabled) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.childrenKeyOfTreeData')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.childrenKey),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "childrenKey", $$v)
      },
      expression: "optionModel.childrenKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.showButtonsColumn')
    }
  }, [_c('el-switch', {
    on: {
      "change": _vm.handleShowButtonsColumnChange
    },
    model: {
      value: (_vm.optionModel.showButtonsColumn),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "showButtonsColumn", $$v)
      },
      expression: "optionModel.showButtonsColumn"
    }
  })], 1), _vm._v(" "), (!!_vm.optionModel.showButtonsColumn) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.buttonsColumnEdit')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.editButtonsColumn
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.editAction')))])], 1) : _vm._e(), _vm._v(" "), (_vm.dataDialogVisible) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.setting.tableDataEdit'),
      "visible": _vm.dataDialogVisible,
      "show-close": true,
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true,
      "width": "75%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dataDialogVisible = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          attrs: {
            "size": "large",
            "type": "primary"
          },
          on: {
            "click": _vm.saveTableData
          }
        }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.confirm')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "large",
            "type": ""
          },
          on: {
            "click": function($event) {
              _vm.dataDialogVisible = false
            }
          }
        }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.cancel')))])], 1)]
      },
      proxy: true
    }], null, false, 1013758083)
  }, [_c('code-editor', {
    attrs: {
      "mode": 'json',
      "readonly": false
    },
    model: {
      value: (_vm.tableDataOptions),
      callback: function($$v) {
        _vm.tableDataOptions = $$v
      },
      expression: "tableDataOptions"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    staticClass: "small-padding-dialog",
    attrs: {
      "title": _vm.i18nt('designer.setting.tableColEdit'),
      "visible": _vm.dialogVisible,
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": "",
      "destroy-on-close": true,
      "width": "1500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          attrs: {
            "size": "large"
          },
          on: {
            "click": _vm.colSubmit
          }
        }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)]
      },
      proxy: true
    }], null, false, 1680061627)
  }, [_c('el-table', {
    ref: "singleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.optionModel.tableColumns,
      "cell-style": {
        padding: '1px 0'
      },
      "height": "500",
      "border": "",
      "row-key": "columnId",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "35",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "160",
      "prop": "columnId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('span', [_vm._v(_vm._s(_vm.i18nt('designer.setting.tableDataColumn')))]) : _c('span', [_vm._v(_vm._s(_vm.getHeaderSpace(scope.row)))])]
      }
    }], null, false, 1315759388)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "30"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-drag drag-option column-drag-handler"
  })]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.columnName'),
      "width": "150",
      "prop": "prop",
      "class-name": "placeholder-hide"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('el-input', {
          model: {
            value: (scope.row.prop),
            callback: function($$v) {
              _vm.$set(scope.row, "prop", $$v)
            },
            expression: "scope.row.prop"
          }
        }) : _c('span', [_vm._v(_vm._s(_vm.getHeaderTitle(scope.row)))])]
      }
    }], null, false, 3884099738)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.columnLabel'),
      "width": "150",
      "prop": "label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.label),
            callback: function($$v) {
              _vm.$set(scope.row, "label", $$v)
            },
            expression: "scope.row.label"
          }
        })]
      }
    }], null, false, 2169776623)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.columnWidth'),
      "width": "100",
      "prop": "width"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('el-input', {
          model: {
            value: (scope.row.width),
            callback: function($$v) {
              _vm.$set(scope.row, "width", $$v)
            },
            expression: "scope.row.width"
          }
        }) : _vm._e()]
      }
    }], null, false, 1172065250)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.visibleColumn'),
      "width": "70",
      "prop": "show"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('el-switch', {
          model: {
            value: (scope.row.show),
            callback: function($$v) {
              _vm.$set(scope.row, "show", $$v)
            },
            expression: "scope.row.show"
          }
        }) : _vm._e()]
      }
    }], null, false, 2521475043)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.customSortColumn'),
      "width": "90",
      "prop": "customSort"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('el-switch', {
          model: {
            value: (scope.row.customSort),
            callback: function($$v) {
              _vm.$set(scope.row, "customSort", $$v)
            },
            expression: "scope.row.customSort"
          }
        }) : _vm._e()]
      }
    }], null, false, 813484873)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.sortableColumn'),
      "width": "70",
      "prop": "sortable"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('el-switch', {
          model: {
            value: (scope.row.sortable),
            callback: function($$v) {
              _vm.$set(scope.row, "sortable", $$v)
            },
            expression: "scope.row.sortable"
          }
        }) : _vm._e()]
      }
    }], null, false, 3392425392)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.fixedColumn'),
      "width": "100",
      "prop": "fixed"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('el-select', {
          model: {
            value: (scope.row.fixed),
            callback: function($$v) {
              _vm.$set(scope.row, "fixed", $$v)
            },
            expression: "scope.row.fixed"
          }
        }, [_c('el-option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("false")]), _vm._v(" "), _c('el-option', {
          attrs: {
            "value": "left"
          }
        }, [_vm._v("left")]), _vm._v(" "), _c('el-option', {
          attrs: {
            "value": "right"
          }
        }, [_vm._v("right")])], 1) : _vm._e()]
      }
    }], null, false, 4179887641)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.alignTypeOfColumn'),
      "width": "100",
      "prop": "align"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          model: {
            value: (scope.row.align),
            callback: function($$v) {
              _vm.$set(scope.row, "align", $$v)
            },
            expression: "scope.row.align"
          }
        }, _vm._l((_vm.alignOptions), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }], null, false, 4186361410)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.formatOfColumn'),
      "width": "200",
      "prop": "formatS"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.headerFlag) ? _c('el-select', {
          attrs: {
            "clearable": ""
          },
          model: {
            value: (scope.row.formatS),
            callback: function($$v) {
              _vm.$set(scope.row, "formatS", $$v)
            },
            expression: "scope.row.formatS"
          }
        }, [_c('el-option-group', {
          key: "custom-render-group",
          attrs: {
            "label": _vm.i18nt('designer.setting.customRenderGroup')
          }
        }, [_c('el-option', {
          attrs: {
            "value": "render",
            "label": "render"
          }
        })], 1), _vm._v(" "), _vm._l((_vm.op), function(group) {
          return _c('el-option-group', {
            key: group.label,
            attrs: {
              "label": group.label
            }
          }, _vm._l((group.options), function(item) {
            return _c('el-option', {
              key: item.value,
              attrs: {
                "label": item.label,
                "value": item.value
              }
            })
          }), 1)
        })], 2) : _vm._e()]
      }
    }], null, false, 1020058985)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.renderFunction'),
      "width": "80",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "disabled": scope.row.formatS !== 'render',
            "size": "mini",
            "plain": "",
            "round": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.showRenderDialog(scope.row)
            }
          }
        })]
      }
    }], null, false, 3915812599)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.i18nt('designer.setting.actionColumn'),
      "width": "100",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          on: {
            "command": function (command) { return _vm.handleAddColCommand(command, scope.$index, scope.row); }
          },
          scopedSlots: _vm._u([{
            key: "dropdown",
            fn: function() {
              return [_c('el-dropdown-menu', [_c('el-dropdown-item', {
                attrs: {
                  "command": "column"
                }
              }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertTableDataColumn')))]), _vm._v(" "), _c('el-dropdown-item', {
                attrs: {
                  "disabled": _vm.disableDropdownItem(scope.row, 'header'),
                  "command": "sub-column"
                }
              }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertTableSubDataColumn')))]), _vm._v(" "), _c('el-dropdown-item', {
                attrs: {
                  "command": "header"
                }
              }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertTableHeader')))]), _vm._v(" "), _c('el-dropdown-item', {
                attrs: {
                  "disabled": _vm.disableDropdownItem(scope.row, 'sub-header'),
                  "command": "sub-header"
                }
              }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.insertTableSubHeader')))])], 1)]
            },
            proxy: true
          }], null, true)
        }, [_c('el-button', {
          attrs: {
            "title": _vm.i18nt('designer.setting.addTableColumn'),
            "size": "small",
            "circle": "",
            "icon": "el-icon-plus"
          }
        })], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "title": _vm.i18nt('designer.setting.deleteTableColumn'),
            "size": "mini",
            "type": "",
            "circle": "",
            "icon": "el-icon-minus"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        })]
      }
    }], null, false, 2715643182)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showButtonsEditDialog) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    attrs: {
      "title": _vm.i18nt('designer.setting.buttonsColumnEdit'),
      "visible": _vm.showButtonsEditDialog,
      "show-close": true,
      "custom-class": "drag-dialog small-padding-dialog",
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true,
      "width": "1120px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showButtonsEditDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          attrs: {
            "size": "default"
          },
          on: {
            "click": function($event) {
              _vm.showButtonsEditDialog = false
            }
          }
        }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)]
      },
      proxy: true
    }], null, false, 982766054)
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "model": _vm.optionModel
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "buttonsColumnTitle",
      "label": _vm.i18nt('designer.setting.buttonsColumnTitle')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.buttonsColumnTitle),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "buttonsColumnTitle", $$v)
      },
      expression: "optionModel.buttonsColumnTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "buttonsColumnWidth",
      "label": _vm.i18nt('designer.setting.buttonsColumnWidth')
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.optionModel.buttonsColumnWidth),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "buttonsColumnWidth", $$v)
      },
      expression: "optionModel.buttonsColumnWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "buttonsColumnFixed",
      "label": _vm.i18nt('designer.setting.fixedColumn')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.optionModel.buttonsColumnFixed),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "buttonsColumnFixed", $$v)
      },
      expression: "optionModel.buttonsColumnFixed"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("false")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v("left")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "right"
    }
  }, [_vm._v("right")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.operationButtonsSetting')))])], 1)], 1), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "tag": "div",
      "list": _vm.optionModel.operationButtons
    }
  }, 'draggable', {
    ghostClass: 'ghost',
    handle: '.drag-handler'
  }, false), _vm._l((_vm.optionModel.operationButtons), function(btn, bIdx) {
    return _c('el-row', {
      key: bIdx,
      staticClass: "button-row",
      attrs: {
        "gutter": 8
      }
    }, [_c('el-col', {
      staticClass: "drag-sort-col",
      attrs: {
        "span": 1
      }
    }, [_c('i', {
      staticClass: "iconfont icon-drag drag-handler"
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'operationButtons.' + bIdx + '.name',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonName'),
        "rules": _vm.nameRules
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": _vm.i18nt('designer.setting.operationButtonName')
      },
      on: {
        "focus": _vm.onButtonNameFocus,
        "change": function (value) { return _vm.onButtonNameChange(value, bIdx); }
      },
      model: {
        value: (btn.name),
        callback: function($$v) {
          _vm.$set(btn, "name", $$v)
        },
        expression: "btn.name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'operationButtons.' + bIdx + '.label',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonLabel')
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": _vm.i18nt('designer.setting.operationButtonLabel')
      },
      model: {
        value: (btn.label),
        callback: function($$v) {
          _vm.$set(btn, "label", $$v)
        },
        expression: "btn.label"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'operationButtons.' + bIdx + '.type',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonType')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.i18nt('designer.setting.operationButtonType')
      },
      model: {
        value: (btn.type),
        callback: function($$v) {
          _vm.$set(btn, "type", $$v)
        },
        expression: "btn.type"
      }
    }, [_c('el-option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("default")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "text"
      }
    }, [_vm._v("text")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "primary"
      }
    }, [_vm._v("primary")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "success"
      }
    }, [_vm._v("success")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "warning"
      }
    }, [_vm._v("warning")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "danger"
      }
    }, [_vm._v("danger")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "info"
      }
    }, [_vm._v("info")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'operationButtons.' + bIdx + '.size',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonSize')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.i18nt('designer.setting.operationButtonSize')
      },
      model: {
        value: (btn.size),
        callback: function($$v) {
          _vm.$set(btn, "size", $$v)
        },
        expression: "btn.size"
      }
    }, [_c('el-option', {
      attrs: {
        "value": "medium"
      }
    }, [_vm._v("medium")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "small"
      }
    }, [_vm._v("small")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "mini"
      }
    }, [_vm._v("mini")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'operationButtons.' + bIdx + '.round',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonRound')
      }
    }, [_c('el-switch', {
      model: {
        value: (btn.round),
        callback: function($$v) {
          _vm.$set(btn, "round", $$v)
        },
        expression: "btn.round"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'operationButtons.' + bIdx + '.hidden',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonHidden')
      }
    }, [_c('el-switch', {
      model: {
        value: (btn.hidden),
        callback: function($$v) {
          _vm.$set(btn, "hidden", $$v)
        },
        expression: "btn.hidden"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'operationButtons.' + bIdx + '.disabled',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonDisabled')
      }
    }, [_c('el-switch', {
      model: {
        value: (btn.disabled),
        callback: function($$v) {
          _vm.$set(btn, "disabled", $$v)
        },
        expression: "btn.disabled"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "icon": "el-icon-delete",
        "plain": "",
        "circle": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteOperationButton(bIdx)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.addOperationButton
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.addOperationButton')))])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showRenderDialogFlag) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    attrs: {
      "title": _vm.i18nt('designer.setting.renderFunction'),
      "visible": _vm.showRenderDialogFlag,
      "append-to-body": "",
      "show-close": true,
      "custom-class": "drag-dialog small-padding-dialog",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showRenderDialogFlag = $event
      }
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "closable": false,
      "title": "function customRender(h, params) {"
    }
  }), _vm._v(" "), _c('code-editor', {
    ref: "dsResultEditor",
    attrs: {
      "mode": 'javascript',
      "readonly": false
    },
    model: {
      value: (_vm.renderJson),
      callback: function($$v) {
        _vm.renderJson = $$v
      },
      expression: "renderJson"
    }
  }), _vm._v(" "), _c('el-alert', {
    attrs: {
      "type": "info",
      "closable": false,
      "title": "}"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveColumnRender
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.i18nt('designer.hint.confirm')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showRenderDialogFlag = false
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.i18nt('designer.hint.cancel')))])], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bb1ce52","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-data-table/data-table-customClass-editor.vue
// module id = null
// module chunks = 